(() => {
  const panel = document.querySelector('.ln-search');
  if (!panel) return;
  const input = panel.querySelector('[data-search-drawer-query-input]');
  const close = panel.querySelector('.yv-search-drawer-close');
  let lastOpen = false;
  const syncQuery = () => panel.classList.toggle('ln-search--query', Boolean(input.value.trim()));
  const positionPanel = () => {
    const announcement = document.querySelector('.announcement-bar-section');
    const bottom = announcement?.getBoundingClientRect().bottom || 0;
    const top = window.matchMedia('(min-width: 768px)').matches ? Math.max(0, bottom) : 0;
    panel.style.setProperty('--ln-search-top', top + 'px');
  };
  window.addEventListener('resize', positionPanel);
  const syncOpen = () => {
    const open = document.body.classList.contains('addsearch');
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
    if (open && !lastOpen) {
      positionPanel();
      syncQuery();
      requestAnimationFrame(() => input.focus());
    }
    if (!open && lastOpen && window.matchMedia('(max-width: 1199px)').matches) {
      requestAnimationFrame(() => document.querySelector('#nav-menu-btn .navbar-toggler')?.focus());
    }
    lastOpen = open;
  };
  input.addEventListener('input', () => {
    syncQuery();
    if (input.value.trim() && typeof window.searchResults === 'function' && window.jQuery) {
      clearTimeout(window.searchTyping);
      window.searchResults(window.jQuery(input));
    }
  });
  input.addEventListener('change', syncQuery);
  panel.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close.click(); }
  });
  document.addEventListener('pointerdown', event => {
    if (document.body.classList.contains('addsearch') && !panel.contains(event.target) && !event.target.closest('[data-search-drawer]')) close.click();
  });
  new MutationObserver(syncOpen).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.querySelectorAll('.lm-search input[name="q"]').forEach(mobileInput => {
    mobileInput.addEventListener('focus', () => {
      const trigger = document.querySelector('header [data-search-drawer="addsearch"]');
      if (!trigger) return;
      document.body.classList.remove('nav-open');
      trigger.click();
    });
  });
  syncQuery();
  syncOpen();
})();
